import React, { Component } from 'react';
import Radium from 'radium';
import Checkbox from './Checkbox';
import UserServices from '../services/UserServices';


class SettingSection extends Component {

	async onToggle() {
		const updatedSettings = await UserServices.savePreference(this.props.preference, !this.props.settings[this.props.preference]);
		this.props.onUpdateSettings(updatedSettings);
	}

	renderPro() {
		if (!this.props.pro) {
			return null;
		}
		
		return (
			<div style={this.props.style.global.pro}>PRO</div>
		);
	}

	renderContent() {
		if (!this.props.children || !this.props.settings[this.props.preference]) {
			return null;
		}

		return (
			<div style={this.localStyles().content}>
				{this.props.children}
			</div>
		);

	}

	render() {
		return (
			<div style={this.localStyles().container}>
				<div style={this.localStyles().titleRow}>
					<div style={this.localStyles().boxHolder}>
						<Checkbox
							on={this.props.settings[this.props.preference]}
							onToggle={() => this.onToggle()}
							style={this.props.style}/>
					</div>
					
					<div style={this.localStyles().textHolder}>
						<div style={this.localStyles().title}>{this.props.title}{this.renderPro()}</div>
						<div>{this.props.description}</div>
					</div>
				</div>
				{this.renderContent()}
			</div>
		);
	}

	localStyles() {
		return {
			boxHolder: {
				width: 50
			},
			title: {
				display: "flex",
				flexDirection: "row",
				fontSize: 20,
				fontWeight: "700",
				marginBottom: 5
			},
			container: {
				display: "flex",
				flexDirection: "column",
				marginBottom: 70
			},
			titleRow: {
				display: "flex",
				flexDirection: "row",
				alignItems: "flex-start",
			},
			textHolder: {
				display: "flex",
				flexDirection: "column",
				flex: 1
			},
			content: {
				marginTop: 20,
				marginLeft: 60
			}
		}
	}
}

export default Radium(SettingSection);


// WEBPACK FOOTER //
// ./src/components/SettingSection.js